<template>
  <div class="racing-iframe-wrap">
    <iframe class="racing-iframe" ref="racingiframeelm" :src="racingIframeSrc" scrolling="no" frameborder="0" @load="iframeLoaded"></iframe>
    <div class="test-ctrls off" ref="racingiframeremoteelm">
      <button class="btn8" @click="iframeLoaded">init</button>
      <button class="btn8" @click="sendMessage4Home()">home</button>
      <button class="btn8" @click="sendMessageToRacingIFrame('login')">login</button>
      <button class="btn8" @click="sendMessage4Logout()">logout</button>
      <button class="btn8" @click="sendMessage4Geolocation()">geolocation</button>
      <button class="btn8" @click="sendMessage4ChangePage()">changePage</button>
      <button class="btn8" @click="sendMessage4DisplayControl()">displayControl</button>
    </div>
  </div>
</template>
<script>
  import config from '@/config'
  import store from '@/store'
  import lib from '@/library'
  import mobileBridge from '@/library/mobileBridge'
  import Session from '@/components/mixins/Session'
  import Geolocation from '@/components/mixins/GeoLocation'
  import Gtm from '@/components/mixins/Gtm'

  export default {
    name: 'racingiframe',

    data () {
      return {
        isListenerRegistered: false,
        indicator4data4uid: null,
        indicator4call4temptoken: null,
        indicator4data4temptoken: null,
        indicator4call4balance: null
      }
    },

    components: {
    },

    mixins: [
      Session,
      Geolocation,
      Gtm
    ],

    filters: {
    },

    computed: {
      state () { return config.app.autoconf.STATE },
      walletProvider () { return config.app.autoconf.WALLET_PROVIDER },
      isLoggedIn () { return store.getters['isLoggedIn'] },
      racingIframeElm () { return this.$refs.racingiframeelm },
      racingIframeSrc () { return config.app.autoconf.RACING_IFRAME_SRC },
      racingIframeSrcOrigin () {
        let src = this.racingIframeSrc.trim()
        let origin = src
        if (src.indexOf('http://') === 0 || src.indexOf('https://') === 0 || src.indexOf('//') === 0) {
          origin = new URL(src).origin
        } else {
          origin = new URL(src, document.baseURI).origin
        }
        return origin
      },
      racingIframeHasTesterPage () {
        return (this.racingIframeSrc + '').indexOf('racing-iframe-tester') > -1
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      isFitForPLayEnabled () {
        return config.app.autoconf.ENABLE_FIT_FOR_PLAY
      }
    },

    methods: {
      iframeLoaded () {
        this.sendMessage4Init()
        this.handleRequest4NotifyEvent({ action: 'pageload', label: 'initial' })
      },

      handleMessageFromRacingIFrame (event) {
        if (!event || !event.origin || event.origin !== this.racingIframeSrcOrigin) {
          return
        }

        let messageName = 'not-for-handling-dummy-message-name'
        try { messageName = event && event.data && event.data.messageName.trim() } catch (e) { }
        switch (messageName) {
          case 'requestLogin':
            this.handleRequest4NotifyEvent({ action: 'request', label: 'login' })
            this.handleRequest4Login()
            break
          case 'keepAlive':
            if (this.isLoggedIn) {
              this.userIsActive()
            }
            break
          case 'updateBalance':
            if (this.isLoggedIn) {
              this.handleRequest4NotifyEvent({ action: 'request', label: 'balance update' })
              store.dispatch('getCustomerContext')
            }
            break
          case 'updateHeight':
            this.handleRequest4UpdateHeight(event.data)
            break
          case 'notifyEvent':
            this.handleRequest4NotifyEvent(event.data)
            break
          case 'displayControl':
            this.handleRequest4DisplayControl(event.data)
            break
          default:
            // console.log('handleMessageFromRacingIFrame but messageName is not supported', event)
            break
        }
      },

      handleRequest4Login () {
        if (this.isLoggedIn) {
          this.sendMessage4Login()
        } else {
          switch (this.walletProvider) {
            case 'GAN':
            case 'FD':
            case 'HALLEY':
              // not supported
              break
            case 'SHW':
            default:
              let faceIdState = (config.app.autoconf.MOBILE_LS && config.app.autoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN) ? JSON.parse(localStorage.biometricsState) : false
              if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && config.app.autoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN && !this.isFitForPLayEnabled)) {
                store.dispatch('overlayState/activateLoginDialog')
                mobileBridge.bridgeSendRequest('readData')
              } else if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && config.app.autoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN && this.isFitForPLayEnabled)) {
                store.dispatch('overlayState/activateLoginDialog')
              } else {
                store.dispatch('overlayState/activateLoginDialog')
              }
              break
          }
        }
      },

      handleRequest4UpdateHeight (data) {
        let iframe = this.racingIframeElm
        if (iframe) {
          let heightSafetyPlus = 0 // a few extra vertical space
          let heightNew = data && data.newHeight && Number.isInteger(data.newHeight) ? parseInt(data.newHeight) : 0

          if (heightNew !== 0 && heightNew > 300) {
            iframe.style.height = (heightNew + heightSafetyPlus).toString() + 'px'
          } else {
            iframe.style.height = null // we (should) have safety min height set via css
          }
        }
      },

      handleRequest4NotifyEvent (data) {
        // type, cat, action, label, module, dataset = {}
        this.sendGTMDataEvent('racing_event', 'interactive', 'message', 'notify', 'racing-iframe', data)
      },

      handleRequest4DisplayControl (data) {
        if (data && data.control) {
          switch (data.control) {
            case 'psws-to-iframe-remote':
              /** @type Element */
              let elm = this.$refs.racingiframeremoteelm
              if (elm) {
                elm.classList.toggle('off')
              }
              break
          }
        }
        // type, cat, action, label, module, dataset = {}
        this.sendGTMDataEvent('racing_event', 'interactive', 'message', 'notify', 'racing-iframe', data)
      },

      sendMessageToRacingIFrame (msgName, msgParams = {}) {
        let iframe = this.racingIframeElm
        if (iframe) {
          switch (msgName) {
            case 'init':
            case 'login': // "tempToken": tempToken, "customerOnlineID": customerOnlineID
            case 'logout':
            case 'home':
            case 'changePage': // "toPage": "PAGE_NAME" of menu|todaysRacing|myBets|results|todaysCarryovers|trackChanges|store
            case 'displayControl': // "type": "LeftSideMenu", works as toggle unless optional value is passed "displayed": true|false
            case 'geolocation': // "geolocated": true
              let msgData = msgParams
              msgData.messageName = msgName
              iframe.contentWindow.postMessage(msgData, this.racingIframeSrcOrigin)
              break
            default:
              console.log('Not supported message for Racing iframe. Message name is', msgName)
              break
          }
        }
      },

      sendMessage4Init () {
        let channel = this.isOpenedFromWebView ? 'mobile' : 'web'
        this.sendMessageToRacingIFrame('init', { channel: channel })
      },
      sendMessage4Login () {
        if (this.indicator4data4uid && this.indicator4data4temptoken) {
          this.sendMessageToRacingIFrame('login', { tempToken: this.indicator4data4uid, customerOnlineID: this.indicator4data4temptoken })
        } else if (this.indicator4call4temptoken) {
          return // block too much calls
        } else {
          let that = this
          this.indicator4call4temptoken = setTimeout(() => {
            that.indicator4call4temptoken = null
          }, 10000) // defensive cleanup
        }

        Promise.resolve()
          .then(() => {
            let indicator4data4uid = this.indicator4data4uid
            if (indicator4data4uid) {
              return indicator4data4uid
            } else {
              let that = this
              return new Promise((resolve, reject) => {
                lib.rpcService.callBroker('iw', 'uid', {})
                  .then((response) => {
                    if (response && response.result) {
                      that.indicator4data4uid = response.result
                      resolve(that.indicator4data4uid)
                    } else {
                      throw new Error('Invalid  UID fetched from server', response)
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                    reject(error)
                  })
              })
            }
          })
          .then((result) => {
            let indicator4data4uid2 = this.indicator4data4uid
            let indicator4data4temptoken2 = this.indicator4data4temptoken

            if (typeof indicator4data4uid2 === 'undefined' || indicator4data4uid2 === null) {
              throw new Error('uid is not available when it should')
            } else if (indicator4data4temptoken2) {
              let data = { uid: indicator4data4uid2, token: indicator4data4temptoken2 }
              return data
            } else {
              let that = this
              return new Promise((resolve, reject) => {
                lib.rpcService.callBroker('SharedWalletService', 'CreateTempId', {})
                  .then((response) => {
                    if (response && response.result) {
                      that.indicator4data4temptoken = response.result
                      clearTimeout(this.indicator4call4temptoken)
                      this.indicator4call4temptoken = setTimeout(() => {
                        that.indicator4call4temptoken = null
                        that.indicator4data4temptoken = null
                      }, 10000)
                      let data = { uid: indicator4data4uid2, token: that.indicator4data4temptoken }
                      resolve(data)
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                    reject(error)
                  })
              })
            }
          })
          .then((result) => {
            this.sendMessageToRacingIFrame('login', { customerOnlineID: result.uid, tempToken: result.token })
          }).catch((error) => {
            console.log(error)
          })
      },
      sendMessage4Logout () {
        this.sendMessageToRacingIFrame('logout')
      },
      sendMessage4Home () {
        this.sendMessageToRacingIFrame('home')
      },
      sendMessage4ChangePage (page = 'todaysRacing') {
        let params = { toPage: 'todaysRacing' }
        switch (page) {
          case 'menu':
          case 'todaysRacing':
          case 'myBets':
          case 'results':
          case 'todaysCarryovers':
          case 'trackChanges':
          case 'store':
            params.toPage = page
            break
          default:
            params.toPage = 'todaysRacing'
            break
        }
        this.sendMessageToRacingIFrame('changePage', params)
      },
      sendMessage4DisplayControl (type = 'LeftSideMenu', displayed = null) {
        let params = { type: type }
        if (typeof displayed !== 'undefined' && displayed !== null) { params.displayed = displayed }
        this.sendMessageToRacingIFrame('displayControl', params)
      },
      sendMessage4Geolocation () {
        let isGeolocated = this.isGeolocated === true
        this.sendMessageToRacingIFrame('geolocation', { geolocated: isGeolocated })
      },

      clearIndicators () {
        this.indicator4data4uid = null
        if (this.indicator4call4temptoken) { clearTimeout(this.indicator4call4temptoken) }
        this.indicator4call4temptoken = null
        this.indicator4data4temptoken = null
        if (this.indicator4call4balance) { clearTimeout(this.indicator4call4balance) }
        this.indicator4call4balance = null
      },

      notifyRacingIframeToDo (args) {
        if (args && args.action) {
          switch (args.action) {
            case 'go-home':
              this.sendMessage4Home()
              break
            case 'toggle-menu':
              this.sendMessage4DisplayControl('LeftSideMenu')
              break
          }
        }
      }
    },

    watch: {
      isLoggedIn (newVal, oldVal) {
        this.clearIndicators()
        if (this.isLoggedIn) { // this should be newVal = true
          this.sendMessage4Login()
        } else {
          this.sendMessage4Logout()
        }
      },
      isGeolocated (newVal, oldVal) {
        this.sendMessage4Geolocation()
      }
    },
    mounted () {
      if (!window.pswsIsRacingIframeListenerRegistered) {
        window.pswsIsRacingIframeListenerRegistered = true
        window.addEventListener('message', this.handleMessageFromRacingIFrame, false)
        this.$root.$on('notifyRacingIframeToDo', this.notifyRacingIframeToDo)
      }
    },
    beforeUnmount () {
      this.clearIndicators()
      if (window.pswsIsRacingIframeListenerRegistered) {
        window.removeEventListener('message', this.handleMessageFromRacingIFrame, false)
        this.$root.$off('notifyRacingIframeToDo', this.notifyRacingIframeToDo)
      }
      window.pswsIsRacingIframeListenerRegistered = false
    }
  }
</script>
<style lang="stylus" scoped>
  .racing-iframe-wrap { position: relative; }
  .racing-iframe { display: block; width: 100%; min-height: 70vh; }
  .test-ctrls { position:absolute; right:0; top:140px; padding:5px; text-align: right; width:100px; overflow:visible; background: linear-gradient(to right, rgba(100,100,100,0), rgb(100, 100, 100)); }
  .test-ctrls.off { display:none }

  .btn8 {
    background-color: #fff; border: 1px solid #888; border-radius: 5px; box-sizing: border-box;
    color: #222; display: inline-block; font-family: system-ui, "Segoe UI", Helvetica, Arial, sans-serif; font-size: 12px; line-height: 16px;
    margin:2px auto; padding: 2px 6px;
  }

  @media only screen and (min-device-width: 1024px) {
    .btn8 { cursor: pointer; }
    .btn8:hover { background-color: #1b9ddb; color:#fff; text-decoration: none; }
    .btn8:active { background-color: #EDEFF2; box-shadow: rgba(225, 228, 232, 0.2) 0 1px 0 inset; }
  }
</style>



// WEBPACK FOOTER //
// src/components/externalintegrations/racing/RacingIframe.vue